import { Component, OnInit } from '@angular/core';
import { CustomModalService } from '@piqet-angular/shared';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-share-link-modal',
  templateUrl: './share-link-modal.component.html',
  styleUrls: ['./share-link-modal.component.scss'],
})
export class ShareLinkModalComponent implements OnInit {
  generatedLink = '';
  linkCopied = false;

  constructor(private modal: CustomModalService, private toastr: ToastrService) {}

  ngOnInit() {
    this.generateLink();
  }

  generateLink() {
    // Get the current organization ID
    const currentOrgId = this.getOrganizationId();

    if (!currentOrgId) {
      this.toastr.error('Organization ID not found');
      return;
    }
    // Generate the URL with the new route format using :id parameter
    const encodedOrgId = btoa(currentOrgId)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');
    this.generatedLink = `${environment.locationPath}/#/create-user/${encodedOrgId}`;
  }

  private getOrganizationId(): string {
    const modalState = this.modal?.modalService?.config?.initialState;
    if (modalState && modalState['organizationId']) {
      return modalState['organizationId'].toString();
    } else {
      return '';
    }
  }

  copyLink(inputElement: HTMLInputElement) {
    inputElement.select();
    document.execCommand('copy');
    this.linkCopied = true;
    this.toastr.success('Link copied to clipboard');

    setTimeout(() => {
      this.linkCopied = false;
    }, 2000);
  }

  onClose() {
    this.modal.close();
  }
}
